import { MessageView, Modal, RealTimeWrapper } from "components";
import {
  useAppLocation,
  useAppSearch,
  useCurrentUser,
} from "_graphql/cache/auth";
import { useCallback } from "react";

import { SendOfferParticipationMessage } from "_graphql/__generated__/globalTypes";
import { SendOfferParticipationMessageMutationVariables } from "_graphql/mutation/__generated__/SendOfferParticipationMessageMutation";
import config from "config";
import { sendOfferParticipationMessage } from "_graphql/visal/mutations/publish-offer";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useParticipationThread } from "hooks/data/use-participation-thread";

export default function OfferTransactionThreadContainer({
  open,
  setOpen,
  hideInput,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
  hideInput?: boolean;
}) {
  const searchParams = useAppSearch();
  const { params } = useAppLocation();
  const { employee } = useCurrentUser();
  const participantId = searchParams?.id || "";
  const [sendMessage, { loading: sendingMessage }] = useMutation<
    SendOfferParticipationMessage,
    SendOfferParticipationMessageMutationVariables
  >(sendOfferParticipationMessage, {
    refetchQueries: ["OfferTransactionThread"],
  });
  const {
    thread,
    loading,
    refetch: refetchThread,
  } = useParticipationThread({
    input: {
      offer_published_participant_id: participantId,
    },
  });
  // const [fetchMessages, { loading: fetchMessagesLoading }] = useQuery(
  //   offerTransactionThread,
  //   {
  //     client: placeItClient,
  //     onCompleted: (data) => {
  //       if (data?.offerTransactionThread) {
  //         setMessages(data.offerTransactionThread);
  //       }
  //     },
  //     onError: (error) => {
  //       toast.error("Failed to load transaction thread");
  //     },
  //   }
  // );

  // useEffect(() => {
  //   if (participantId && open) {
  //     setLoading(true);
  //     fetchMessages({
  //       variables: {
  //         input: {
  //           offer_published_participant_id: participantId,
  //         },
  //       },
  //     }).finally(() => setLoading(false));
  //   }
  // }, [participantId, open, fetchMessages]);

  const handleSubmit = useCallback(
    async (values: { message: string }) => {
      try {
        sendMessage({
          variables: {
            input: {
              firstname: employee?.employee_first_name || "",
              lastname: employee?.employee_last_name || "",
              message: values.message,
              offer_published_participant: participantId,
              offer_published_id: params?.offer || "",
            },
          },
        })
          .then((res) => {
            toast.success("Message sent successfully");
            form.resetForm();
          })
          .catch((err) => {
            toast.error("Failed to send message");
          });
      } catch (error) {
        toast.error("Failed to send message");
      }
    },
    [employee?.employee_first_name, employee?.employee_last_name]
  );

  const form = useFormik({
    initialValues: {
      message: "",
    },
    onSubmit: handleSubmit,
  });

  // const renderActions = useCallback(
  //   () => (
  //     <>
  //       <OfficeButton
  //         size="sm"
  //         loading={sendingMessage}
  //         onClick={wrapClick(form.handleSubmit)}
  //       >
  //         Send
  //       </OfficeButton>
  //     </>
  //   ),
  //   [form.handleSubmit]
  // );

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      size="3xl"
      title="Transaction Thread"
      hideActions={true}
      description="Communication thread with Reinsurance Underwriters on KAVAr"
      // renderActions={renderActions}
    >
      <div className="bg-blue-100 rounded-none mb-4 p-2">
        <p className="text-xs text-blue-800 px-4 pt-2">
          Secure Transactional Threads enable realtime, encrypted communication
          between communicating parties, ensuring confidential negotiations.
        </p>
        <p className="text-xs text-blue-800 px-4 pt-2">
          When both parties are online, they can collaborate instantly—sharing
          documents, discussing terms, and closing deals faster. Key benefits
          include end-to-end security, live interaction, and streamlined
          workflows for time-sensitive transactions.
        </p>
      </div>
      <RealTimeWrapper
        channel={config.pusher.channels.kava}
        events={[
          "reinsurer.interest",
          "reinsurer.remove_interest",
          "reinsurer.thread_notification",
        ]}
        callBack={() => refetchThread()}
      >
        <MessageView
          offers={thread.map((msg) => ({
            ...msg,
            __typename: "OfferMessageContent", // TODO: This should probably be changed.
            // uuid: msg.uuid || `temp-${Date.now()}-${Math.random()}`,
            // sender_name: msg.sender_name || "Unknown",
            // state: "INTERNAL",
            source: msg.from,
            timestamp: msg.timeStamp,
            message: msg.message,
          }))}
          hideInput={hideInput}
          form={form}
          sending={sendingMessage}
        />
      </RealTimeWrapper>
    </Modal>
  );
}
